export default class Base{
  // admin_host = "https://user-admin.student-open.com"
  admin_host = "https://student-open-user-admin.quantumtri.com"
	web_admin_host = ''
  // admin_host = "http://localhost:8081"
  // host = "https://legoasapi.legoas.co.id"
  host = "https://api.student-open.com"
  // host = "https://student-open-api.quantumtri.com"
  // host = ""
  url_api = this.host + "/api"
  version = "0.0.0001"
  locale_string = "id-ID"
  locale_timezone = "Asia/Jakarta"
  local_currency = "Rp."
  local_area_phone = "+62"
  wait_time = 1500
  app_version = '0.2.0107'
	mode = ''
  enabled_encrypt = false
  encrypt_key = ''
  req_param_encrypt = 'column'

	cutoff_str = 'Cut-Off'
	cutoff_tournament_str = 'Cut-Off + Tournament'

  host2 = "https://lelang.legoas.co.id:8443"
  url_api2 = this.host2 + "/api/portal"
  auth = "Basic ODUwMWRjNjRiOTEzNDcyZmE0Mjc0MTE5MTEzYjdjNGQ6TFNTLWRjYTU0ZDQ0ODFjZDRlYTU4NDAwYzk4NDM3N2EzMzk1"

  constructor(){
		// this.host = process.env.VUE_APP_HOST
		// this.academic_host = process.env.VUE_APP_ACADEMIC_HOST
		// this.admin_host = process.env.VUE_APP_ADMIN_HOST
		// this.web_admin_host = process.env.VUE_APP_WEB_ADMIN_HOST
		// this.url_api = process.env.VUE_APP_HOST + process.env.VUE_APP_URL_API
		// this.url_academic_api = process.env.VUE_APP_ACADEMIC_HOST + process.env.VUE_APP_URL_API
		// this.mode = process.env.VUE_APP_MODE
    // this.enabled_encrypt = process.env.VUE_APP_ENABLED_ENCRYPT
    // this.encrypt_key = process.env.VUE_APP_ENCRYPT_KEY
    // this.req_param_encrypt = process.env.VUE_APP_REQ_PARAM_ENCRYPT

		// this.locale_timezone = process.env.VUE_APP_TIMEZONE
		// this.locale_string = process.env.VUE_APP_LOCALE_STRING
		// this.local_currency = process.env.VUE_APP_LOCALE_CURRENCY
		// this.local_area_phone = process.env.VUE_APP_LOCALE_AREA_PHONE
		// this.wait_time = process.env.VUE_APP_WAIT_TIME

		this.cutoff_str = 'Cut-Off'
		this.cutoff_tournament_str = 'Cut-Off & Tournament'
  }

  validate_email(email){
    return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }

  async save_tab(title, tab_data){
		var arr_tab = await window.localStorage.getItem('arr_tab')
		arr_tab = arr_tab != null ? JSON.parse(arr_tab) : []
    
    var index = -1
		for(let x in arr_tab){
			if(arr_tab[x].url == window.location.pathname){
				index = x
				break
			}
		}

    var obj = {
      title: title,
      url: window.location.pathname,
      tab_data: tab_data,
    }
    if(index < 0)
      arr_tab.push(obj)
    else
      arr_tab[index] = obj

		window.localStorage.setItem('arr_tab', JSON.stringify(arr_tab))
	}

	async get_tab(){
		var arr_tab = await window.localStorage.getItem('arr_tab')
		arr_tab = arr_tab != null ? JSON.parse(arr_tab) : []

		var selected_page = {}
		for(let tab of arr_tab){
			if(tab.url == window.location.pathname){
				selected_page = tab
        break
			}
		}

		return selected_page
	}

  async reset_tab(url_destination){
		var arr_tab = await window.localStorage.getItem('arr_tab')
		arr_tab = arr_tab != null ? JSON.parse(arr_tab) : []

		var selected_page = {}
		for(let tab of arr_tab){
			if(tab.url == url_destination){
				tab.tab_data = ''
        break
			}
		}

		window.localStorage.setItem('arr_tab', JSON.stringify(arr_tab))
	}

  check_phone_format(data){
    return data.length > 0 && data[data.length - 1].match(/^[\d\s]+$/g) == null ? data.substring(0, data.length - 1) : data
  }

  str_to_double(data, default_value = '0'){
    var value
    if(data != '')
      value = parseFloat(data.replace(/\./g,'').replace(/,/g,'.'))
    else
      value = default_value
    return value
  }

  responsive_scroll_threshold(value, additional_margin = 0){
    if(window.screen.width < 720)
      value = value * (12 / 16) + additional_margin
    else if(window.screen.width >= 720 && window.screen.width < 1024)
      value = value * (8 / 16)
    // console.log(value)
    return value
  }

  check_start_animation(scrollY, flag, arr_factor, scroll_threshold = 0, additional_margin = 0){
    var temp = true
    for(let factor of arr_factor){
      if(!factor){
        temp = false
        break
      }
    }

    return (flag || (!flag && scrollY >= this.responsive_scroll_threshold(scroll_threshold, additional_margin))) && temp
  }

  phone_validation(data, max_length = 12){
    data = String(this.str_to_double(data, ''))
    if(isNaN(data))
      data = '0'
    if(data.charAt(0) === '0')
      data = data.slice(1)
    if(max_length > 0 && data.length > max_length)
      data = data.substring(0, max_length)
    return data
  }

	timer_validation(data, max_length = 2){
		var value = ''
		for(let x = 0; x < data.length; x++){
			if(!isNaN(data[x]))
				value += data[x]
		}
		if(value == '')
			value = '0'

		if(value.length > max_length)
			value = value.substring(0, value.length - 1)

		return value
	}

  to_currency_format(data, max_number = 10000000000, max_comma_length = 2){
    var value = data

    if(value[value.length - 1] !== ","){
      var is_include_comma = false
      var is_convert_double = true
      var index_comma = 0
      for(let x = 0; x < value.length; x++){
        if(value[x] === ","){
          is_include_comma = true
          index_comma = x
        }
        else if(is_include_comma && x == value.length - 1 && value[x] === "0")
          is_convert_double = false
      }

      if(is_include_comma){
        is_convert_double = value.length - index_comma > max_comma_length && value[value.length - 2] !== "0"
        value = value.substring(0, index_comma + 1 + max_comma_length)
      }


      if(is_convert_double){
        value = this.str_to_double(value)
        if(isNaN(value))
          value = 0
        if(value > max_number)
          value = max_number
      }
    }

    return value.toLocaleString(this.locale_string)
  }

	init_duration(timer){
		var temp1 = timer.toLocaleString().split('.')[0]
		var temp = timer.toLocaleString().split('.')[1]

		// console.log(temp1)
		// console.log(temp)

		return momentTZ.duration({
			seconds: timer,
			// milliseconds: temp != null ? (temp.length == 1 ? temp + '00' : temp.length == 2 ? temp + '0' : temp) : '0',
		})
	}

	async toDataURL(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function() {
			var reader = new FileReader();
			reader.onloadend = function() {
				callback(reader.result);
			}
			reader.readAsDataURL(xhr.response);
		};
		xhr.open('GET', url);
		xhr.responseType = 'blob';
		xhr.send();
	}

	async toDataURLPromise(url) {
		return new Promise((resolve, reject) => {
			var xhr = new XMLHttpRequest();
			xhr.onload = function() {
				var reader = new FileReader();
				reader.onloadend = function() {
					resolve(reader.result);
				}
				reader.readAsDataURL(xhr.response);
			};
			xhr.open('GET', url);
			xhr.responseType = 'blob';
			xhr.send();
		})
	}

  show_error(message = ""){
    // showSnackBar({
    //   message: message,
    //   textColor: '#FFF',      // message text color
    //   position: 'top',  // enum(top/bottom).
    //   confirmText: '', // button text.
    //   duration: 2000,   // (in ms), duartion for which snackbar is visible.
    // })
    alert(message)
    // console.log(message)
    // this.$toasted.show(message)
    // sessionStorage.removeItem('message')
  }
}
